// @flow

import { observer } from "mobx-react";
import React from "react";

import type { Props } from "app/components/TimelineCard/TimelineCard";
import ShortComment from "app/components/ShortComment/ShortComment";
import TimelineItemOverlay from "app/components/TimelineItemOverlay/TimelineItemOverlay";
import AppearanceStore from "app/stores/AppearanceStore";
import "./MapTimelineCard.scss";

@observer
export default class MapTimelineCard extends React.Component<Props> {
    get length(): number {
        return AppearanceStore.timelineContentLength;
    }

    handleReadMore = () => {
        this.props.onExpand();
    }

    render() {
        return this.props.isVerticalView
            ? this.renderVerticalView()
            : this.renderHorizontalView();
    }

    renderVerticalView() {
        return this.props.isExpanded
            ? this.renderVerticalViewExpanded()
            : this.renderVerticalViewShrunk();
    }

    renderVerticalViewExpanded() {
        const item = this.props.item;
        const description =
            item.metaCoords || item.metaDescription || item.metaTitle;
        if (!description) return null;

        const apiKey = window["google_maps_api_key"];
        const iframeSrc = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${description}`;

        return (
            <div className="MapTimelineCard">
                <ShortComment
                    itemId={item.rowid}
                    comment={item.comment}
                    length={this.length}
                    onReadMore={this.handleReadMore}
                />
                <div className="MapTimelineCard__iframeContainer">
                    <iframe
                        src={iframeSrc}
                        className="MapTimelineCard__iframe"
                        frameBorder={0}
                        title="Map"
                        style={{ width: "100%", height: "400px" }}
                    />
                </div>
            </div>
        );
    }

    renderVerticalViewShrunk() {
        const item = this.props.item;
        const metaImage = item.metaImage;
        const src = metaImage ? metaImage.src : "";
        const hasText = item.metaTitle || item.metaDescription || item.comment.length > 0;
        const imageContainerClass = hasText 
            ? "TimelineCard--linkable__imageContainer"
            : "TimelineCard--linkable__imageContainer_notext";

        return (
            <div className="MapTimelineCard">
                {/* {this.renderOverlay()} */}
                <div onClick={this.props.onExpand}>
                    <div className="TimelineCard--linkable">
                        <div className="TimelineCard--linkable__container">
                            { this.props.isExpanded
                                ? this.renderMap()
                                : (
                                    <button
                                        type="button"
                                        className="TimelineCard--overlayable__button"
                                        onClick={this.props.onExpand}
                                    >
                                        <div className={imageContainerClass}>
                                            <img
                                                className="TimelineCard--linkable__image"
                                                src={src}
                                                alt="Timeline item"
                                            />
                                        </div>
                                    </button>
                                )
                            }
                            
                            {hasText &&
                                <div className="TimelineCard--linkable__titleAndDescriptionContainer">
                                    {item.metaTitle && (
                                        <div className="TimelineCard--linkable__title">
                                            {item.metaTitle}
                                        </div>
                                    )}

                                    {item.metaDescription && (
                                        <div className="TimelineCard--linkable__description">
                                            {item.metaDescription}
                                        </div>
                                    )}
                                    <ShortComment
                                        itemId={item.rowid}
                                        comment={item.comment}
                                        length={this.length}
                                        onReadMore={this.handleReadMore}
                                    />
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderHorizontalView() {
        const item = this.props.item;
        const metaImage = item.metaImage;
        const src = metaImage ? metaImage.src : "";

        const classes = ["MapTimelineCard", "TimelineCard--overlayable"];
        if (this.props.isExpanded) {
            classes.push("MapTimelineCard__expanded");
        }


        return (
            <div className={classes.join(" ")}>

                <ShortComment
                    itemId={item.rowid}
                    comment={item.comment}
                    length={this.length}
                    key={item.rowid}
                    onReadMore={this.handleReadMore}
                />

                { this.props.isExpanded
                    ? this.renderMap()
                    : (
                        <button
                            type="button"
                            className="TimelineCard--overlayable__button"
                            onClick={this.props.onExpand}
                        >
                            <img
                                className="TimelineCard--overlayable__image"
                                src={src}
                                alt="Timeline item"
                            />
                        </button>
                    )
                }

                <div className="TimelineCard--overlayable__content">
                    <a href={item.metaUrl} target="_blank">
                        {item.metaTitle && (
                            <div className="TimelineCard--overlayable__title">
                                {item.metaTitle}
                            </div>
                        )}

                        {item.metaDescription && (
                            <div className="TimelineCard--overlayable__description">
                                {item.metaDescription}
                            </div>
                        )}
                    </a>
                </div>
            </div>
        );
    }

    renderMap() {
        const item = this.props.item;
        const description =
            item.metaCoords || item.metaDescription || item.metaTitle;
        if (!description) return null;

        const apiKey = window["google_maps_api_key"];
        const iframeSrc = `https://www.google.com/maps/embed/v1/place?key=${apiKey}&q=${description}`;

        return (
            <iframe
                src={iframeSrc}
                className="MapTimelineCard__iframe"
                frameBorder={0}
                title="Map"
            />
        );
    }


    renderOverlay() {
        const item = this.props.item;
        const description =
            item.metaCoords || item.metaDescription || item.metaTitle;
        if (!description) return null;
        return (
            <TimelineItemOverlay
                {...this.props}
                onClose={this.props.onUnExpand}
                overlayVisible={this.props.isExpanded}
            >
                {this.renderMap()}
            </TimelineItemOverlay>
        );
    }
}



// WEBPACK FOOTER //
// ./src/app/components/TimelineCard/MapTimelineCard/MapTimelineCard.js